// export const API_URL = "http://10.2.3.129:8000/api/v1";
// export const API_URL = "http://10.2.3.86:8000/api/v1";
// export const API_URL = "http://10.2.3.197:8000/api/v1";
// export const API_URL = "http://10.5.252.48:8000/api/v1";
// export const API_URL = "http://10.2.3.172:8000/api/v1";
export const API_URL = "https://api.spbi.dolphin.com.np/api/v1";
export default API_URL;
